
export const Loading = () => {
    return (
        <div className='h-screen items-center justify-center flex'>Loading...</div>
    )
}
